import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import Icon from "./Icon";
import T from "./translations/Translations";

import { grades } from "../const/Grades";

/**
 * @name Marquee
 * @param {{}} student
 * @param {[]} studentImageList
 * @returns {JSX.Element}
 */
const Marquee = ({ student, studentImageList }) => {
    const [studentImage, setStudentImage] = useState(null);
    const [studentName, setStudentName] = useState(null);

    const { address, firstName, gradeName, lastName, middleName, schoolName, studentNumber } = student;

    const newStudentStr = T({ key: "Marquee_NewStudent" });

    /**
     * Set the selected student's image if there is one
     */
    useEffect(() => {
        if (student && studentImageList) {
            const tmpImage = studentImageList.find((obj) => obj.studentNumber === student.studentNumber);
            if (tmpImage) {
                setStudentImage(tmpImage);
            } else {
                setStudentImage(null);
            }
        }
    }, [student, studentImageList]);

    /**
     * Set the student name string
     */
    useEffect(() => {
        if (student) {
            if (studentNumber) {
                setStudentName(`${firstName} ${middleName} ${lastName} - (${studentNumber})`);
            } else {
                setStudentName(`${firstName} ${middleName} ${lastName} - (${newStudentStr})`);
            }
        }
    }, [firstName, lastName, middleName, newStudentStr, student, studentNumber]);

    return (
        <div className="marquee-container">
            <div>
                {studentImage ? (
                    <div className="image-container">
                        <img alt={firstName} src={studentImage.imageUrl} />
                    </div>
                ) : (
                    <div className="no-image-container">
                        <Icon className="pb-3" fill="#19608F" height={140} iconName="NO_STUDENT_IMAGE" width={140} />
                    </div>
                )}
            </div>
            <div className="info-card">
                <div className="name">{studentName}</div>
                <hr />
                <table>
                    <tbody>
                        <tr>
                            <td className="label" valign="top" width="70">
                                {/* Grade: */}
                                {T({ key: "Marquee_Grade" })}:
                            </td>
                            <td className="info" valign="top">
                                {grades(gradeName)}
                            </td>
                        </tr>
                        <tr>
                            <td className="label" valign="top" width="80">
                                {/* School: */}
                                {T({ key: "Marquee_School" })}:
                            </td>
                            <td className="info" valign="top">
                                {schoolName || "Not Available"}
                            </td>
                        </tr>
                        <tr>
                            <td className="label" valign="top" width="90">
                                {/* Address: */}
                                {T({ key: "Marquee_Address" })}:
                            </td>
                            <td className="info" valign="top">
                                <div>{address.addressLine1}</div>
                                <div>{address.addressLine2}</div>
                                <div>
                                    {address.city}, {address.state} {address.zip}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

Marquee.propTypes = {
    student: PropTypes.oneOfType([PropTypes.object]).isRequired,
    studentImageList: PropTypes.instanceOf(Array)
};

Marquee.defaultProps = {
    studentImageList: []
};

export default Marquee;
